<template>
    <zen-one :showuserinfo="false" title="Cukai Tanah:: Laporan Terimaan" :crumbs="crumbs">
        <z-page :title="`Laporan Terimaan Mengikut Daerah`" :append-button="true">
            <w-flex column :gap="3">
                <w-form @submit.prevent="filter">
                    <w-flex column :gap="3">
                        <w-flex :columns="{ xs: 1 }" :gap="3">
                            <w-input type="date" v-model="searchParams.tarikh_dari" outline label="Tarikh Dari"
                                label-position="left">
                            </w-input>
                            <w-input type="date" v-model="searchParams.tarikh_hingga" outline label="Tarikh Hingga"
                                label-position="left">
                            </w-input>
                            <w-button :loading="loading" class="align-self-end" type="submit">
                                <w-icon>fal fa-search</w-icon>&nbsp;Cari
                            </w-button>
                        </w-flex>
                    </w-flex>
                </w-form>
                <w-flex class="justify-space-between">
                    <w-button bg-color="success" :loading="loading" class="align-self-end" @click="printPdf()">
                        <w-icon class=" mr2 "> fal fa-print</w-icon>
                        &nbsp;Cetak
                    </w-button>
                </w-flex>
            </w-flex>

            <br>
            <w-card :loading="loading">
                <p>TERIMAAN HASIL KESELURUHAN BAGI DAERAH</p>
                <table class="table-dashboard" width="100%" loading="loading">
                    <thead>
                        <tr>
                            <!-- <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">Bil</td> -->
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">Kod Akaun</td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">Perihal</td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">Kaunter (RM)</td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">Kiosk (RM)</td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">Luar Daerah (RM)
                            </td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">iBayaq (RM)</td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">Kaunter Bergerak
                                Daerah(RM)</td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">Kaunter Bergerak
                                Luar Daerah(RM)</td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">Pelarasan Deposit
                                iHasil (RM)</td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; ">Jumlah (RM)</td>
                        </tr>
                    </thead>
                    <tbody v-if="terimaan.length != 0">
                        <tr v-for="w in terimaan">
                            <td>{{ w.kod }}</td>
                            <td>{{ w.keterangan }}</td>
                            <td align="right">{{ total1(kira('kaunter', w), kira('xdeKaunter', w)) }}</td>
                            <td align="right">{{ kira('kiosk', w) }}</td>
                            <td align="right">{{ kira('luarDaerah', w) }}</td>
                            <td align="right">{{ kira('ibayaq', w) }}</td>
                            <td align="right">{{ kira('kaunterGerok', w) }}</td>
                            <td align="right">{{ kira('kaunterGerokLuarDaerah', w) }}</td>
                            <td align="right">{{ kira('deposit', w) }}</td>
                            <td align="right">{{ total(w) }}</td>
                        </tr>
                        <tr>
                            <td colspan="2">Jumlah</td>
                            <td align="right">{{ total1(jumlah('kaunter'), jumlah('xdeKaunter')) }}</td>
                            <td align="right">{{ jumlah('kiosk') }}</td>
                            <td align="right">{{ jumlah('luarDaerah') }}</td>
                            <td align="right">{{ jumlah('ibayaq') }}</td>
                            <td align="right">{{ jumlah('kaunterGerok') }}</td>
                            <td align="right">{{ jumlah('kaunterGerokLuarDaerah') }}</td>
                            <td align="right">{{ jumlah('deposit') }}</td>
                            <td align="right">{{ belake() }}</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="9" align="center">
                                Tiada Maklumat
                            </td>
                        </tr>
                    </tbody>
                </table>
                <br>
            </w-card>
        </z-page>
    </zen-one>
</template>

<script>
import moment from "moment";
import ZResource from "@/Modules/z-resource";

export default {
    extends: ZResource,
    components: {

    },
    data() {
        return {
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            loading: false,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Senarai", route: "/cukai-tanah/senarai" },
            ],
            terimaan: [],
            searchParams: {
                tarikh_dari: new Date().toJSON().slice(0, 10),
                tarikh_hingga: new Date().toJSON().slice(0, 10),
                jabatan: this.$page.props.auth.user.jabatan_id,
                user: this.$page.props.auth.user.name,
            },
        };
    },
    methods: {
        printPdf() {
            Object.keys(this.searchParams).forEach((key) => {
                if (this.searchParams[key] === null) {
                    delete this.searchParams[key];
                }
            });
            var queryString = Object.keys(this.searchParams)
                .map((key) => key + "=" + this.searchParams[key])
                .join("&");
            // console.log(queryString);
            window.open(`${this.apiBaseUrl}/cukai/laporan/laporanTerimaanDaerahPdf?${queryString}`, "_blank");
        },
        filter() {
            this.searchParams.status =
                this.searchParams.status === "null"
                    ? null
                    : this.searchParams.status;
            this.dataGet();
        },
        async dataGet() {
            this.loading = true;
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/laporan/laporanTerimaanDaerah`,
                params: this.searchParams,
                responseType: "json",
            }).then((e) => {
                this.terimaan = e.data;
            });
            this.loading = false;
        },
        kira(q, e) {
            // console.log(q);
            // console.log(e.data[0].jenis)
            const f = e.data;
            for (var i = 0; i < f.length; i++) {
                if (f[i].jenis == q) {
                    return parseFloat(f[i].amaun, 2).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            }
            return parseFloat(0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        total1(x, y) {
            var u = parseFloat(x.replace(/,/g, ''), 2) + parseFloat(y.replace(/,/g, ''), 2)
            return parseFloat(u, 2).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        total(e) {
            var jumlah = 0;
            const f = e.data;
            for (var i = 0; i < f.length; i++) {
                var amaun = parseFloat(f[i].amaun);
                jumlah = amaun + jumlah;
            }
            return parseFloat(jumlah).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        jumlah(jen) {
            var jum = 0;
            for (var i = 0; i < this.terimaan.length; i++) {
                const f = this.terimaan[i].data;
                for (var x = 0; x < f.length; x++) {
                    if (f[x].jenis == jen) {
                        jum = parseFloat(f[x].amaun) + jum;
                    }
                }
            }
            return parseFloat(jum).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        belake() {
            var jum = 0;
            for (var i = 0; i < this.terimaan.length; i++) {
                const f = this.terimaan[i].data;
                for (var x = 0; x < f.length; x++) {
                    jum = parseFloat(f[x].amaun) + jum;
                }
            }
            return parseFloat(jum).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

    },
    mounted() {
        // this.dataJHM();
        this.dataGet();
    },
};
</script>
